import React, {Fragment} from "react";
import DropdownComponent from "./DropdownComponent";
import UtilityCountryList from "../services/utility/UtilityCountryList";
import UtilityCountry from "../domain/Util/UtilityCountry";

export default class CountryDropdownComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      countryList: null
    };

    this.onCountryListLoaded = this.onCountryListLoaded.bind(this)
  }

  componentDidMount() {
    UtilityCountryList.retrieveCountryList(this.onCountryListLoaded);
  }

  onCountryListLoaded(countryList) {
    if (this.props.showAllOption) {
      countryList = [
        UtilityCountry.create("", "", "All Countries"),
        ...countryList
      ]
    }
    this.setState({
      countryList: countryList
    })
  }

  render() {
    return <Fragment>{
      UtilityCountryList.COUNTRY_LIST === null ? <Fragment>Loading...</Fragment>
        : <DropdownComponent
          {...this.props}
          options={this.state.countryList}
          optionText={"name"}
          optionValue={"alpha3"}
        />
    }
    </Fragment>
  }
}
